export const Latest_Tranding = "Latest_Tranding";
export const Movies ="Movies";
export const Shows = "Shows";
export const Carousel_data = "Carousel_data";